import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Card,
  CardMedia,
  CardContent,
  IconButton,
  useTheme,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import BlogDetailsScreen from "./BlogDetailsScreen";
import { fetchBlogsByCategory } from "../../../apiservices/ApiService";
import PWAHeader from "../../../common/PWAHeader";


const CategoryDetails = ({ category, onBack }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBlogUrl, setSelectedBlogUrl] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const data = await fetchBlogsByCategory({ category });
        setBlogs(data.blogs || []);
      } catch (error) {
        console.error("Error loading blogs by category:", error);
      } finally {
        setLoading(false);
      }
    };

    loadBlogs();
  }, [category]);

  if (selectedBlogUrl) {
    return (
      <BlogDetailsScreen
        blogUrl={selectedBlogUrl}
        onBack={() => setSelectedBlogUrl(null)}
      />
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{  }}>

      <PWAHeader title={category} onBack={onBack} />

      {/* Blogs List */}
      <Box sx={{padding: theme.spacing(2), backgroundColor: "rgba(255, 152, 0, 0.11)"}}>
      {blogs.map((blog, index) => (
        <Card
          key={index}
          variant="outlined"
          onClick={() => setSelectedBlogUrl(blog.blogUrl)}
          sx={{
            marginBottom: theme.spacing(2),
            background: "linear-gradient(to top, #fff 0%, #FF9800 100%)",
            border: "1px solid #771615",
            boxShadow: theme.shadows[1],
            cursor: "pointer",
          }}
        >
          <CardMedia
            component="img"
            image={blog.blogImage}
            alt={blog.blogTitle}
            sx={{ height: 200, objectFit: "cover" }}
          />
          <CardContent>
            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{ marginBottom: theme.spacing(1) }}
            >
              {blog.blogTitle}
            </Typography>
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ marginBottom: theme.spacing(1), display: "block" }}
            >
              {blog.blogRead} Reads • {blog.minsToRead} min read
            </Typography>
          </CardContent>
        </Card>
      ))}
      </Box>
    </Box>
  );
};

export default CategoryDetails;